import React, { useState, useEffect } from "react";
import "../styles/navbar.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Add subtle shadow on scroll
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`navbar-wrapper ${scrolled ? "scrolled" : ""}`}>
      {/* ===== Top White Bar ===== */}
      <div className="topbar">
        <div className="topbar-left">
          <img
            src={process.env.PUBLIC_URL + "/assets/logo.png"}
            alt="Lak Derana Cabs"
            className="logo"
          />
          <div className="brand">
            <span className="line1">LAK DERANA</span>
            <span className="line2">CABS</span>
          </div>
        </div>

        <a href="tel:0774504505" className="hotline">
          <i className="fa fa-phone"></i> 077&nbsp;450&nbsp;450&nbsp;5
        </a>
      </div>

      {/* ===== Main Black Navbar ===== */}
      <nav className="main-nav">
        <button
          className={`menu-toggle ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
        >
          <span className="bar bar1"></span>
          <span className="bar bar2"></span>
          <span className="bar bar3"></span>
        </button>

        <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
          <li><a href="/">Home</a></li>
          <li><a href="/book">Book</a></li>
          <li><a href="/fleet">Fleet</a></li>
          <li><a href="/rates">Rates</a></li>
          <li><a href="/contact">Contact</a></li>
        </ul>
      </nav>
    </header>
  );
}
